import { render, staticRenderFns } from "./myPsCheckOrder.vue?vue&type=template&id=5944d386&scoped=true&"
import script from "./myPsCheckOrder.vue?vue&type=script&lang=js&"
export * from "./myPsCheckOrder.vue?vue&type=script&lang=js&"
import style0 from "./myPsCheckOrder.vue?vue&type=style&index=0&id=5944d386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944d386",
  null
  
)

export default component.exports